import { Alert, Box, Chip, ListItem, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const DialogHeader = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const HeaderTitleBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 16,
}));

export const Dropzone = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'dragOver',
})<{ dragOver?: boolean }>(({ dragOver }) => ({
  border: `2px dashed ${dragOver ? 'rgb(2, 122, 242)' : '#fafafa17'}`,
  borderRadius: 16,
  padding: 48,
  marginTop: 24,
  textAlign: 'center',
  cursor: 'pointer',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  backgroundColor: dragOver ? 'rgba(2, 122, 242, 0.05)' : 'transparent',
  '&:hover': {
    borderColor: 'rgb(2, 122, 242)',
  },
}));

export const UploadCircle = styled(Box)(() => ({
  width: 80,
  height: 80,
  borderRadius: '50%',
  background: 'linear-gradient(135deg, rgb(2, 122, 242) 0%, rgb(2, 122, 242) 100%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0 auto 24px',
}));

export const FileInfoGrid = styled(Box)(() => ({
  marginTop: 24,
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
  gap: 16,
}));

export const FileInfoBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  // A grid track sizes to its content unless told otherwise, so without this a long value
  // widens the column and pushes the whole grid past the dialog.
  minWidth: 0,
}));

export const InfoLabel = styled(Typography)(() => ({
  fontWeight: 500,
  fontSize: '0.875rem',
}));

export const InfoValue = styled(Typography)(() => ({
  marginTop: 4,
  fontSize: '1rem',
  fontWeight: 400,
  // File names and ids carry no spaces to wrap at, so allow a break anywhere. Wrapping
  // rather than truncating: the point of showing the name is confirming the right file was
  // picked, and what distinguishes two similar names is usually at the end.
  overflowWrap: 'anywhere',
}));

export const StyledAlert = styled(Alert)(() => ({
  borderRadius: 12,
  '& .MuiAlert-icon': { fontSize: 24 },
}));

export const InspectionItem = styled(ListItem)(() => ({
  cursor: 'pointer',
  paddingTop: 12,
  paddingBottom: 12,
  paddingLeft: 0,
  paddingRight: 0,
}));

export const StyledChip = styled(Chip)(() => ({
  fontWeight: 500,
  fontSize: '0.75rem',
}));

export const SectionHeader = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: 16,
  paddingBottom: 8,
  borderBottom: '1px solid #fafafa17',
}));

export const SectionTitle = styled(Typography)(() => ({
  fontWeight: 600,
  fontSize: '1.125rem',
  color: 'text.primary',
}));

export const SearchContainer = styled(Box)(() => ({
  marginBottom: 16,
}));

export const SelectAllContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
}));
